/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LogoutInputs */

const en_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const de_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {LogoutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const logout = /** @type {((inputs?: LogoutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LogoutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_logout(inputs)
	return en_logout(inputs)
});